import { template } from 'underscore';
import Backbone from 'backbone';
export default Backbone.View.extend({
  initialize() {
    var alreadyVisible = $('.designer-marketplace-overlay').length;
    if (!alreadyVisible) {
      this.render();
    }
  },
  events: {},
  template: template(
    `    
    <div class="designer-marketplace-overlay">
    </div>
        `
  ),
  render() {
    $('body').append(this.template());
  }
});
